import {Injectable} from '@angular/core';
import {MxPermissionService, PermissionActions} from 'mx-core';
import {Observable, of} from 'rxjs';


/**
 * Hold current authenticated user name and its permissions
 */
@Injectable({
    providedIn: 'root'
})
export class PrlPermissionService implements MxPermissionService {

    private userName: string;

    constructor() {
    }

    init(): Observable<void> {
        return of();
    }

    destroy(): void {

    }


    /**
     * Can evaluate permission expression like 'permission.field.presets.add &&
     * (permission.field.agent.edit || permission.accounts.view)'
     */
    hasPermission(perm: string): boolean {
        return true;
    }



    hasRole(role: string): boolean {
        return true;
    }

    getEditPermission(permission: string): string {
        return '';
    }

    getPermissionActions(permission: string): PermissionActions {
        return undefined;
    }

    getPermissionWithoutAction(permission: string): string {
        return '';
    }

}
